import { Typography } from 'antd';
import React from 'react';
import {
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { EvaluationAcousticMistake } from './block5Components/EvaluationAcousticMistake';
import { EvaluationRemainingMistakes } from './block5Components/EvaluationRemainingMistakes';

export const Block5 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 8 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Vertinimas:
        </Typography.Title>
        <EvaluationAcousticMistake form={form} />
        <EvaluationRemainingMistakes form={form} />
      </div>
    );
  },
);
